import { FC } from "react";
import { Link } from "react-router";

interface TablePlayerNameProps {
    photoUrl: string;
    url?: string;
    name: string;
}

export const TablePlayerName: FC<TablePlayerNameProps> = ({ photoUrl, name, url }) => {
    return (
        <Link to={url} className="transition-all group flex flex-row items-center gap-2 px-1">
            <div className="transition-all h-12 w-12 min-w-12 sm:h-16 sm:w-16 border-2 border-white rounded-full overflow-hidden shadow-sm group-hover:shadow-lg">
                <img className="transition-all group-hover:scale-105 w-full h-full object-contain object-top" src={photoUrl} />
            </div>
            <div className="text-left uppercase">{name}</div>
        </Link>
    );
}
